import React, { Fragment, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { API, handleError, postRequestConfig } from './api';
import { useTranslation } from 'react-i18next';

import './form.css';
import UserSettingsContext from './UserSettingsContext';

function VerifyEmail() {
  const { t } = useTranslation('translations');

  const location = useLocation();
  const history = useHistory();
  const { userSettings, setUserSettings } = useContext(UserSettingsContext);
  const { emailVerificationToken, passwordVerificationToken } = userSettings;
  const { state = {} } = location;
  const { email } = state;
  const verify = state.verify
  || (passwordVerificationToken && 'password')
  || (emailVerificationToken && 'email');

  const [checking, setChecking] = useState(undefined);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(undefined);

  const [code, setCode] = useState(passwordVerificationToken || emailVerificationToken || '');

  const active = useRef(true);

  const verifyEmail = useCallback((token) => {
    setProcessing(true);
    return fetch(`${API}/verify/email`, {
      ...postRequestConfig,
      body: `token=${
        encodeURIComponent(token)
      }`,
    })
    .then(handleError)
    .then(() => {
      if (!active.current) {
        // We have been unmounted already
        return;
      }
      setProcessing(false);
      setUserSettings({
        ...userSettings,
        emailVerificationToken: undefined,
      });
      history.push('/verified');
    })
    .catch((error) => {
      if (!active.current) {
        // We have been unmounted already
        return;
      }
      console.error(error);
      setError(error);
      setProcessing(false);
    });
  }, [history, setUserSettings, userSettings]);

  function verifyPassword() {
    setProcessing(true);
    setUserSettings({
      ...userSettings,
      passwordVerificationToken: code,
    });
    history.push('/password');
  }

  function processForm(event) {
    event.preventDefault();
    if (processing) {
      return;
    }
    switch(verify) {
      case 'email':
        verifyEmail(code);
        break;
      case 'password':
        verifyPassword();
        break;
      default: 
    }
  }

  useEffect(() => {
    return () => {
      active.current = false;
    } 
  }, []);

  useEffect(() => {
    if (emailVerificationToken) {
      setChecking(true);
      verifyEmail(emailVerificationToken)
      .finally(() => {
        setChecking(false);
      });
    } else {
      setChecking(false);
    }
  }, [emailVerificationToken, verifyEmail]);

  if (passwordVerificationToken) {
    return <Redirect to={{ pathname: '/password' }} />;
  }

  if (checking || (checking === undefined)) {
    return null;
  }

  if (!email && !emailVerificationToken) {
//    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <header>
        <h1>{t('Please check your email!')}</h1>
      </header>
      <main>
        { email
        ? (
          <p>{t('We sent a confirmation email to', { email })}</p>
        )
        : (
          <p>{t('We sent a confirmation message to your email.')}</p>
        )
        }
        <p>
          {t('Please click on the link in the email or copy the confirmation code here.')}
        </p>
        <form onSubmit={processForm}>
          <section>
            <div>
              <input
                id="code"
                className={(code) ? 'has-content' : ''}
                type="text"
                name="one-time-code"
                value={code}
                onChange={(event) => setCode(event.target.value)}
                placeholder=""
              />
              <label htmlFor="code">{t('Confirmation code')}</label>
              <span className="focus-border"></span>
            </div>
          </section>
          <input
            type="submit"
            disabled={processing || !code}
            value="OK"
          />
        </form>
      </main>
      {error
        ? <p className="error">{error.message || JSON.stringify(error)}</p>
        : undefined
      }
    </Fragment>
  );
}

export default VerifyEmail;
